import * as React from 'react'
import {Util} from 'yougile-util'
import {TaskData} from 'yougile-model'
import {UserProxy} from '../../../extensions/proxies/user-proxy'
import {WithScrollbar} from '../../common/with-scrollbar/with-scrollbar'
import {ByUserColumnHeader} from './by-user-column-header'
import {ByUserColumnStage} from './by-user-column-stage'

interface Props {
  user: UserProxy | undefined
  tasks: TaskData[]
}

export class ByUserColumn extends React.Component<Props> {
  public override render(): JSX.Element | null {
    const {user, tasks} = this.props
    const bem = Util.bemFrom('by-user', 'column')
    const allTasks = tasks.filter(task =>
      user ? task.assigned.includes(user.userId) : !task.assigned
    )

    if (!user && allTasks.length === 0) {
      return null
    }

    return (
      <div className={bem()}>
        <ByUserColumnHeader user={user} tasks={tasks} />
        <WithScrollbar
          className={bem('item-list')}
          contentClassName={bem('item-list-content')}
          verticalScrollbarStyle={{borderRadius: '8px', minHeight: '32px'}}
        >
          {!!user && (
            <>
              <ByUserColumnStage tasks={tasks} stage={'current'} user={user} />
              <ByUserColumnStage tasks={tasks} stage={'done'} user={user} />
            </>
          )}
          {!user && (
            <ByUserColumnStage tasks={tasks} stage={'new'} paging={10} />
          )}
        </WithScrollbar>
      </div>
    )
  }
}
